import { Center, Loader } from '@mantine/core';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const Done = () => {
  const [searchParams] = useSearchParams();
  useEffect(() => {
    const state = searchParams.get('state');
    const host = window.location.host;
    const url = `https://${host}/api/payment/success?state=${state}`;
    console.log(`Done, navigating parent from ${window.opener?.location.href} to ${url}`);
    window.opener?.location.replace(url);
    window.close();
  }, [searchParams]);

  return (
    <Center>
      <Loader />
    </Center>
  );
};

export default Done;
